import React from "react"
import style from "./content.module.css"

export default ({children}) => (
<div className={style.content}>
    {children}
</div>
)